<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：商品管理-商品编辑-基础信息
    -->
  <div class="basic-setting-content pl16 pr16">
    <el-form-item label="身份证号码:" prop="waiter.auth.idCard">
      <el-input v-if="form.waiter.auth" v-model="form.waiter.auth.idCard" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="身份证正面:" prop="waiter.auth.idCardFront">
      <el-row>
        <el-button type="primary" @click="openProductUpload('image', 'service_image')">选择图片</el-button>
        <div v-if="form.waiter.auth && form.waiter.auth.idCardFront!=''" class="img">
          <img :src="form.waiter.auth.idCardFront" width="100" height="100" />
        </div>
      </el-row>
    </el-form-item>
    <el-form-item label="身份证反面:" prop="waiter.auth.idCardBack">
      <el-row>
        <el-button type="primary" @click="openProductUpload('image','group_image')">选择图片</el-button>
        <div v-if=" form.waiter.auth && form.waiter.auth.idCardBack!=''" class="img">
          <img :src="form.waiter.auth.idCardBack" width="100" height="100" />
        </div>
      </el-row>
    </el-form-item>
    <el-form-item label="身份证手持照:" prop="waiter.auth.idCardHand">
      <el-row>
        <el-button type="primary" @click="openProductUpload('image','mp_image')">选择图片</el-button>
        <div v-if="form.waiter.auth && form.waiter.auth.idCardHand!=''" class="img">
          <img :src="form.waiter.auth.idCardHand" width="100" height="100" />
        </div>
      </el-row>
    </el-form-item>
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import Technician from "@/api/technician.js";
import DataApi from "@/api/data.js";
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      isProductUpload: false,
      config: {},
      file_name: "image",
      areaList: []
    };
  },
  inject: ["form"],
  created() {
    // console.log("==============form", this.form);
  },

  methods: {
    /*打开上传图片*/
    openProductUpload: function(fileType, file_name) {
      this.file_name = file_name;
      if (fileType == "image") {
        this.config = {
          total: 1,
          fileType: "image"
        };
      } else {
        this.config = {
          total: 1,
          fileType: "video"
        };
      }
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        if (this.file_name == "video") {
          this.form.waiter.video_id = e[0].fileId;
          this.form.waiter.video = e[0];
        } else if (this.file_name == "service_image") {
          this.form.waiter.auth.idCardFront = e[0].filePath;
        } else if (this.file_name == "group_image") {
          this.form.waiter.auth.idCardBack = e[0].filePath;
        } else if (this.file_name == "mp_image") {
          this.form.waiter.auth.idCardHand = e[0].filePath;
        }
      }
      this.isProductUpload = false;
    },
    handleClose(tagItem) {
      this.form.waiter.tag.splice(this.form.waiter.tag.indexOf(tagItem), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        if (this.form.waiter.tag == null) {
          this.form.waiter.tag = [];
        }
        this.form.waiter.tag.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    }
  }
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/part/idcard.vue